import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputNumber} from "primereact/inputnumber";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import {Calendar} from "primereact/calendar";
import axios from "axios";

const RetentionFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [paymentStatuses, setPaymentStatuses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [fulfilments, setFulfilments] = useState([]);
  const [isDateOnlyEdit, setIsDateOnlyEdit] = useState(false);
  const [vatRate, setVatRate] = useState([]);
  const [isLockedByClosedFulfillment, setIsLockedByClosedFulfillment] = useState(false);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (values, form) => {
    setLoading(true)
    if (isLockedByClosedFulfillment) {
      setLoading(false);
      return;
    }
    const payload = buildRetentionPayload(values);
    if ((window.App.urlVars().retentionId) || (entity === 'retention' && id)) {
      apiCall('patch', '/api/v2/retention/' + (window.App.urlVars().retentionId ?? id), payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderRetentionList: Math.random()})
          if (props.goback === true) {
            if(entity === 'project') {
              history.go(-1)
            } else {
              history.push(props.backlink);
            }
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/retention', payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderRetentionList: Math.random()})
          if (props.goback === true) {
            if(entity === 'project') {
              history.go(-1)
            } else {
              history.push(props.backlink);
            }
          } else {
            history.push('/finance/retention/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const getId = (v) => (typeof v === 'object' && v !== null ? v.id : v);

  const getSelectedCategory = (values) => {
    const catId = getId(values?.retention_category);
    return categories?.find(c => Number(c.id) === Number(catId));
  };

  const isClosedStatus = (status) => {
    const normalized = String(status || '').toUpperCase();
    return normalized === 'CLOSED' || normalized === 'DELETED';
  };
  const isEditMode = (!!window.App.urlVars().retentionId) || (entity === 'retention' && id);
  const onlyReleaseDateEditable =
    isClosedStatus(formData?.fulfillment?.status) &&
    !!formData?.retention_category?.release_on_date &&
    String(formData?.payment_status || '').toUpperCase() !== 'PAID';

  const fullyLocked =
    isClosedStatus(formData?.fulfillment?.status) &&
    !onlyReleaseDateEditable;

  const buildRetentionPayload = (values) => {
    const formattedReleaseDate = values.release_date
      ? `${values.release_date.getFullYear()}-${String(values.release_date.getMonth() + 1).padStart(2, '0')}-${String(values.release_date.getDate()).padStart(2, '0')}`
      : null;

    if (onlyReleaseDateEditable) {
      return {
        release_date: formattedReleaseDate,
      };
    }
    const retention_category = Number(getId(values.retention_category));
    const fulfillment = Number(getId(values.fulfillment));
    const selectedCat = categories?.find(c => Number(c.id) === Number(retention_category));
    const ratePercent = !!selectedCat?.rate_percent;
    const payload = {
      retention_category,
      fulfillment,
      release_date: formattedReleaseDate,
    };
    if (selectedCat?.vat_rate === true) {
      payload.vat_rate = Number(getId(values.vat_rate));
    }
    if (ratePercent) {
      return {
        ...payload,
        percentage: Number(values.percentage) || 0,
      };
    }
    return {
      ...payload,
      amount: Number(values.amount) || 0,
    };
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    if(window.App.urlVars().fulfillmentId) {
      setFormData({
        fulfillment: Number(window.App.urlVars().fulfillmentId)
      })
    }
  }, [window.App.urlVars().fulfillmentId])

  useEffect(() => {
    setIsDateOnlyEdit(false);
    setIsLockedByClosedFulfillment(false);
    apiCall('get', '/api/v2/retention-category')
      .then(response => {
        setCategories(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/dictionary/payment-status')
      .then(response => {
        setPaymentStatuses(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/vat-rate')
      .then(response => {
        setVatRate(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/fulfillment')
      .then(response => {
        setFulfilments(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if ((!window.App.urlVars().create && window.App.urlVars().retentionId) || (entity === 'retention' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/retention/' + (window.App.urlVars().retentionId ?? id))
        .then(async response => {
          const data = response.data.data;
          if (data?.fulfillment?.id && !data.fulfillment.status) {
            try {
              const fRes = await apiCall('get', '/api/v2/fulfillment/' + data.fulfillment.id);
              data.fulfillment.status = fRes.data.data.status;
            } catch (e) {
              console.error(e);
            }
          }
          const parentClosed = isClosedStatus(data?.fulfillment?.status);
          const hasReleaseOnDate = !!data?.retention_category?.release_on_date;
          const isPaid = String(data?.payment_status || '').toUpperCase() === 'PAID';
          const dateOnlyEditable = parentClosed && hasReleaseOnDate && !isPaid;

          setIsDateOnlyEdit(dateOnlyEditable);
          setIsLockedByClosedFulfillment(parentClosed && !dateOnlyEditable);
          setFormData({
            ...data,
            release_date: data.release_date ? new Date(data.release_date) : null,
          })
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  if (isEditMode && !formData?.id && loading) {
    return (
      <div className={"retention-form widget"}>
        <ProgressBar
          mode="indeterminate"
          style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0}}
        />
      </div>
    );
  }

  return (
    <div className={"retention-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting, values, form}) => {
              const selectedCat = getSelectedCategory(values);
              const ratePercent = !!selectedCat?.rate_percent;
              const hasReleaseDate = !!selectedCat?.release_on_date;
              return (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            {!onlyReleaseDateEditable && (
            <div className={"p-col-12 p-lg-6"}>
              <Field name="retention_category" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="retention_category"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCategory')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(categories, "name")}
                               disabled={onlyReleaseDateEditable || fullyLocked}
                               id={"retention_category"}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noCategoryYet')}
                               onChange={(e) => {
                                 input.onChange(e.value);
                                 const cat = categories.find(c => Number(c.id) === Number(e.value));
                                  if (cat?.rate_percent) {
                                    form.change('amount', null);
                                  } else {
                                    form.change('percentage', null);
                                  }
                               }}
                               value={Number(window.App.urlVars().categoryId) || getId(input.value)}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            )}
            {/* <div className={"p-col-12 p-lg-6"}>
              <Field name="fulfillment" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="retention_category"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDeliveryDate')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(fulfilments, "name")}
                               disabled={window.App.urlVars().fulfillmentId}
                               id={"fulfillment"}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noCompletionYet')}
                               onChange={(e) => input.onChange(e.value)}
                               value={formData.fulfillment?.id || formData.fulfillment}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div> */}
            {!onlyReleaseDateEditable && (
              <>
            {ratePercent ? (
            <div className={"p-col-12 p-lg-6"}>
              <Field name="percentage" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="percentage"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPercentage')}</label>
                  <span className="p-d-block">
                      <InputNumber id="percentage"
                                   disabled={onlyReleaseDateEditable || fullyLocked}
                                   value={input.value ?? null}
                                   mode="decimal"
                                   locale="hu-HU"
                                   precision={2}
                                   maxFractionDigits={2}
                                   minFractionDigits={0}
                                   onValueChange={(e) => input.onChange(e.value)}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            ) : (
              <div className={"p-col-12 p-lg-6"}>
                <Field name="amount" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="amount" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAmount')}</label>
                    <InputNumber
                      id="amount"
                      value={input.value}
                      disabled={onlyReleaseDateEditable || fullyLocked}
                      onValueChange={(e) => input.onChange(e.value)}
                      className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      mode="decimal"
                      maxFractionDigits={2}
                      minFractionDigits={0}
                      precision={2}
                    />
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            )}
              </>
            )}
            {selectedCat?.vat_rate === true && (
              <div className={"p-col-12 p-lg-6"}>
                <Field name="vat_rate" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="vat_rate" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldVatRate')}</label>
                    <span className="p-d-block">
                      <Dropdown options={window.App.sortDropdownOptions(vatRate, "label")}
                                id={"vat_rate"}
                                optionValue={"id"}
                                optionLabel={"label"}
                                emptyMessage={t('noVatLowerYet')}
                                value={getId(input.value)}
                                onChange={(e) => input.onChange(e.value)}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            )}
            {hasReleaseDate && (
              <div className={"p-col-12 p-lg-6"}>
                <Field name="release_date" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="release_date" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPaymentDueDays')}</label>
                    <Calendar
                      locale="hu"
                      showIcon
                      dateFormat="yy-mm-dd"
                      id="release_date"
                      value={input.value}
                      disabled={isLockedByClosedFulfillment}
                      onChange={(e) => input.onChange(e.value)}
                      className={classNames({'p-invalid': isFormFieldValid(meta)})}
                    />
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            )}
            {/* <div className={"p-col-12 p-lg-6"}>
              <Field name="payment_status" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="payment_status"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPaymentStatus')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(paymentStatuses, "value")}
                               id={"payment_status"}
                               optionValue={"key"}
                               optionLabel={"value"}
                               emptyMessage={t('noStateYet')}
                               value={input.value}
                               onChange={(e) => input.onChange(e.value)}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div> */}

          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'retention' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}}/>
    </div>
  )
}
export default withTranslation('common')(RetentionFormComponent);
